import {Component, Inject} from '@angular/core';
import {of, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, map, mergeMap} from 'rxjs/operators';
import {AccountService} from '../../../../../domain/core/service/account.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AssistanceService} from '../../../../../domain/assistance/service/assistance.service';
import {Account} from '../../../../../domain/core/model/account';
import {UserContextService} from '../../../../../application/app-context/user-context/user-context.service';
import {SafeSubscriberDirective} from '../../../../../application/app-context/safe-subscriber.directive';
import {TranslateService} from '@ngx-translate/core';

@Component({
             templateUrl: './home-assistance-duplicate-dialog.component.html'
           })
export class HomeAssistanceDuplicateDialogComponent extends SafeSubscriberDirective {

  keyUp = new Subject<any>();
  showSpinnerResearch: boolean | undefined;
  filteredAccounts: Array<Account> | undefined;
  selectedAccount: Account | undefined;

  constructor(private contextService: UserContextService,
              private translateService: TranslateService,
              private accountService: AccountService,
              public dialogRef: MatDialogRef<HomeAssistanceDuplicateDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private assistanceService: AssistanceService) {
    super();
    this.subs.push(this.keyUp.pipe(
      map(event => event.target.value),
      debounceTime(400),
      distinctUntilChanged(),
      mergeMap(search => {
        this.showSpinnerResearch = true;
        return search ? this.accountService.search(search) : of(this.accountsForEmptySearch());
      }))
                       .subscribe(accounts => {
                         this.showSpinnerResearch = false;
                         this.filteredAccounts = accounts;
                       }, error => console.error('Error while performing search...\n' + error)));

  }

  selectAccount(account: Account): void {
    this.selectedAccount = account;
  }

  duplicate(): void {
    if (this.selectedAccount !== undefined) {
      this.assistanceService.duplicateAssistance(this.data.assistance, this.selectedAccount)
          .subscribe(() => this.dialogRef.close());
    }
  }

  private accountsForEmptySearch(): Array<Account> {
    const userContext = this.contextService.getUserContext();
    return userContext.user.accounts;
  }

  message(): string {
    return this.selectedAccount
           ? this.translateService.instant('assistance.duplicate.duplicate', {account: this.selectedAccount.name})
           : this.translateService.instant('assistance.duplicate.no-selected-account');
  }
}
